// Decodifica o payload de um JWT sem validar assinatura (só leitura de claims no
// frontend — a validação de verdade é sempre feita pelo backend). Usado pra extrair a
// claim "idUsuario" (id legado numérico) do token emitido pela Uzerpass.Seguranca, já que
// a resposta de login não traz mais esse campo (ver docs/plano-integracao-api-seguranca.md).
export function decodificarPayloadJwt(token) {
  try {
    const partes = token.split('.');
    if (partes.length < 2) return null;

    const base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - (base64.length % 4)) % 4);
    const json = decodeURIComponent(
      atob(base64 + padding)
        .split('')
        .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
    );

    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}
